/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCostSavingsCalculation extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCostSavingsCalculation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCostSavingsCalculation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCostSavingsCalculation>): BackgroundJobPayloadForPeriodicCostSavingsCalculation {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCostSavingsCalculation(), model);
        BackgroundJobPayloadForPeriodicCostSavingsCalculation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCostSavingsCalculation>): BackgroundJobPayloadForPeriodicCostSavingsCalculation {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCostSavingsCalculation.newInstance(<BackgroundJobPayloadForPeriodicCostSavingsCalculation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCostSavingsCalculation) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCostSavingsCalculation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCostSavingsCalculation): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCostSavingsCalculation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
